import React, { useMemo } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { buildTypeOptions, RelationshipLabelSelector } from '../../../../../modernization-common/relationships/components/relationship-editor';
import { relationshipLabelsAtom, selectedLabelNameAtom, sourceObjectIdAtom } from '../../../atoms/relationship-atoms';
import { allAnnotationMapAtom } from '../../../atoms/side-panel-atoms';
type RelationshipSelectorPropsT = {
  isVideoTask: boolean;
};
export const RelationshipSelector = ({
  isVideoTask
}: RelationshipSelectorPropsT) => {
  const relationshipLabels = useAtomValue(relationshipLabelsAtom);
  const sourceId = useAtomValue(sourceObjectIdAtom);
  const allAnnotationsDataMap = useAtomValue(allAnnotationMapAtom);
  const sourceClass = allAnnotationsDataMap[sourceId]?.annotation.annotationLabel.title;
  const relationshipLabelsForSource = useMemo(() => {
    return relationshipLabels.filter(label => sourceClass !== undefined && label.classConstraints.source.includes(sourceClass));
  }, [relationshipLabels, sourceClass]);
  const selectedLabelName = useAtomValue(selectedLabelNameAtom);
  const setSelectedLabelName = useSetAtom(selectedLabelNameAtom);
  const typeOptions = buildTypeOptions(relationshipLabelsForSource, isVideoTask);
  return <RelationshipLabelSelector typeOptions={typeOptions} selectedLabelName={selectedLabelName} onTypeChange={setSelectedLabelName} />;
};